import { Pipe, PipeTransform } from "@angular/core";
import { Ng2SearchPipe } from "./ng2-search-search.pipe";

// Filters by search term (reusing Ng2SearchPipe's logic) then groups the result into rows of `size`,
// keeping the item type concrete so it can safely feed *cdkVirtualFor/*ngFor/trackBy.
@Pipe({
    name: 'filterChunk',
    standalone: false
})
export class FilterChunkPipe implements PipeTransform {

  transform<T>(items: T[], term: string | null | undefined, size: number): T[][] {
    if (!items || !items.length) {
      return [];
    }

    const filtered = term ? Ng2SearchPipe.filter(items as Array<{ [key: string]: any }>, term, []) as T[] : items;

    const chunks: T[][] = [];
    for (let i = 0; i < filtered.length; i += size) {
      chunks.push(filtered.slice(i, i + size));
    }
    return chunks;
  }

}
